import datepicker from 'js-datepicker';

const Datepicker = () => {

  let picker = datepicker('.datepicker', {});

};

export default Datepicker;